RivalIQ.apps.AdsInsights.module('widgets', function (widgets, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    const MAX_SPARKLINE_DAYS = 90;

    const MetricView = widgets._GlanceMetricView = RivalIQ.apps.Dashboard.widgets.MetricView.extend({
        regions: {
            sparkline: '.x-sparkline-region'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles,
            Information: {
                behaviorClass: RivalIQ.behaviors.Information
            }
        },

        setInformationForTooltip: function () {
            const me = this;

            const metric = me.dashboardModel.metric;

            const content = (me.redactResultsMetric ?
                RivalIQ.strings.facebook_ads_insights_glance_cross_campaign_description :
                RivalIQ.metric.render.description(metric));

            const information = {
                title: RivalIQ.metric.names.metricName(metric),
                content: content
            };

            _.set(me.model, ['attributes', 'information'], information);
        },

        onAttachLoaded: function () {
            const me = this;
            if (!me.redactResultsMetric && me.sparkData) {
                me.sparkline.show(new RivalIQ.graph.Spark({
                    data: me.sparkData
                }));
            }
        },

        shouldShowSparkline: function () {
            const me = this;

            const timePeriod = me.getProp('timePeriod');
            const numDaysInPeriod = RivalIQ.utils.timePeriod.getPeriodCount(moment.utc(timePeriod.mainPeriodStart), moment.utc(timePeriod.mainPeriodEnd));

            const sparklineRequested = me.dashboardModel.hasSparkline || me.dashboardModel.hasCumulativeSparkline;

            // Don't show the cross-campaign sparkline, it's super expensive to calculate for any moderately sized account.
            const isCrossCampaign = (me.getProp('adObjectId') === me.getProp('adAccountId'));

            return Boolean(sparklineRequested) && numDaysInPeriod <= MAX_SPARKLINE_DAYS && !isCrossCampaign;
        },

        serializeData: function () {
            const me = this;

            const metric = me.dashboardModel.metric;
            if (me.redactResultsMetric) {
                const data = {
                    metric: {
                        name: RivalIQ.metric.names.metricName(metric),
                        value: 'N/A'
                    },
                    submetric: {
                        displayString: RivalIQ.strings.facebook_ads_insights_glance_cross_campaign_warning
                    },
                    submetricDisplayType: me.getProp('submetricDisplayType'),
                    warnings: {}
                };

                return data;
            } else {
                return RivalIQ.apps.Dashboard.widgets.MetricView.prototype.serializeData.call(me);
            }
        },

        loadData: function () {
            const me = this;

            // no need to go get it, it's statically defined.
            if (me.getProp('metricValue')) {
                return new $.Deferred().resolve();
            }

            const metric = me.dashboardModel.metric;
            const submetric = me.dashboardModel.submetric;

            let sparkMetric = null;
            if (me.shouldShowSparkline()) {
                sparkMetric = RivalIQ.metric.build(metric, {
                    dimensions: ['day'],
                    cumulativeDailyValues: me.dashboardModel.hasCumulativeSparkline
                });
            }

            const metrics = _.compact([metric, submetric, sparkMetric]);
            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .done(function (collection) {
                    let metricIdx = 0;
                    me.model = collection.at(metricIdx++);
                    if (submetric) {
                        me.submetric = collection.at(metricIdx++);
                    }

                    if (sparkMetric) {
                        me.sparkMetric = collection.at(metricIdx++);
                        me.sparkData = _.map(me.sparkMetric.getValue({
                            rawValue: true
                        }), _.last);
                    }

                    me.redactResultsMetric = false;
                    if (_.includes(['results', 'cost_per_result'], metric.property)) {
                        me.redactResultsMetric = _.has(me.model.getValue({
                            rawValue: true
                        }), 'noResultsReason');
                    }
                    me.setInformationForTooltip();
                });
        }
    });

    const GlanceMetricWidget = widgets._GlanceMetricWidget = RivalIQ.apps.Dashboard.widgets.MetricWidget.extend({

        view: MetricView,

        processProps: function (props) {
            const me = this;

            me.metric = _.extend({}, me.metric, props);
            if (me.submetric) {
                me.submetric = _.extend({}, me.submetric, props);
            }

            return props;
        }
    });
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.ADS_INSIGHTS_METRIC, GlanceMetricWidget);


    const Glance = RivalIQ.apps.Dashboard.views.ColumnWidgets.extend({
        columnWidth: 3,
        panelView: undefined,
        className: 'panel-body',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        },

        // TODO this could be more efficient by not re-rendering
        refresh: function () {
            const me = this;
            me.render();
        },

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        }
    });

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const GlanceWidget = widgets._GlanceWidget = Widget.extend({
        title: RivalIQ.strings.facebook_ads_insights_glance_title,
        description: RivalIQ.strings.facebook_ads_insights_glance_description,

        pngView: App.views.PngPanel,
        pdfView: App.views.PdfPanel,
        getExportSubtitle: App.utils.exportSubtitle,

        view: Glance,
        viewMore: false,

        getFilename: function () {
            const me = this;
            return App.utils.getExportFilename(me.getProps(), me.curation.adObject, me.getTitle());
        },

        processProps: function (props) {
            const me = this;

            const metricAttrs = {
                source: RivalIQ.enums.sources.FACEBOOK_ADS,
                channel: 'facebook',
                dimensions: ['timeAnalysisMode', 'adObjectId', 'channel'],
                adObjectId: props.adObjectId,
                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
            };

            me.metric = RivalIQ.metric.build(props, metricAttrs);

            return props;
        },

        widgetDefinitions: function () {
            const me = this;

            const metric = me.metric;

            return [
                {
                    instanceId: 'cost-per-mille',
                    widgetId: RivalIQ.enums.widgetTypes.ADS_INSIGHTS_METRIC,
                    metric: RivalIQ.metric.build(metric, {
                        property: 'cpm'
                    }),
                    submetric: RivalIQ.metric.build(metric, {
                        name: 'Total Spent',
                        property: 'spend'
                    }),
                    hasSparkline: true
                },
                {
                    instanceId: 'frequency',
                    widgetId: RivalIQ.enums.widgetTypes.ADS_INSIGHTS_METRIC,
                    metric: RivalIQ.metric.build(metric, {
                        property: 'frequency'
                    }),
                    submetric: RivalIQ.metric.build(metric, {
                        property: 'impressions'
                    }),
                    hasCumulativeSparkline: true
                },
                {
                    instanceId: 'click-through-rate',
                    widgetId: RivalIQ.enums.widgetTypes.ADS_INSIGHTS_METRIC,
                    metric: RivalIQ.metric.build(metric, {
                        property: 'ctr'
                    }),
                    submetric: RivalIQ.metric.build(metric, {
                        property: 'clicks'
                    }),
                    hasSparkline: true
                },
                {
                    instanceId: 'cost-per-result',
                    widgetId: RivalIQ.enums.widgetTypes.ADS_INSIGHTS_METRIC,
                    metric: RivalIQ.metric.build(metric, {
                        property: 'cost_per_result'
                    }),
                    submetric: RivalIQ.metric.build(metric, {
                        property: 'results',
                        name: 'Total Results'
                    }),
                    hasSparkline: true
                }
            ];
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.ADS_INSIGHTS_GLANCE, GlanceWidget);
}, window.moment);
